export const types = {
  login: '[auth] Login',
  logout: '[auth] Logout',
  selectAccount: 'Select account',
  editProfile: 'Edit profile'
}
